import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", {
    class: "emp-card",
    key: `emp-${_ctx.employeeId}`
  }, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dsIntretinuti,
      ref: "dataGridRef",
      "allow-column-reordering": true,
      "allow-column-resizing": true,
      "column-auto-width": false,
      "show-borders": true,
      "key-expr": "Id"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxScrolling, {
          mode: "standard",
          "show-scrollbar": 'always'
        }),
        _createVNode(_component_DxColumnFixing, { enabled: true }),
        _createVNode(_component_DxEditing, {
          "allow-updating": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: 700,
              height: 450,
              "show-title": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.saveButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Name",
          caption: "Nume",
          width: "150"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Surname",
          caption: "Prenume",
          width: "180"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Cnp",
          caption: "CNP",
          width: "150"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Sex",
          caption: "Sex",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "BornDate",
          caption: "Data Nasterii",
          width: "140"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "RelativeId",
          caption: "Tip Rudenie",
          width: "150"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "FromDate",
          caption: "De la",
          width: "140"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ToDate",
          caption: "Pana la",
          width: "140"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Coasigurat",
          caption: "Coasigurat",
          width: "100"
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "add",
                  type: "success",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.addPopupVisible,
      "show-title": true,
      height: 450,
      width: 700
    }, {
      title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "data-source": _ctx.formData,
          "label-alignment": "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, { "data-field": "Nume" }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Prenume" }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Sex" }),
            _createVNode(_component_DxSimpleItem, { "data-field": "CNP" }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Data Nasterii",
              "editor-type": "dxDateBox"
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Tip Rudenie" }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "De la",
              "editor-type": "dxDateBox"
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Pana la",
              "editor-type": "dxDateBox"
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Coasigurat",
              "editor-type": "dxCheckBox"
            })
          ]),
          _: 1
        }, 8, ["data-source"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.addButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.closeButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}